import React, { useEffect } from "react";
import { string } from "prop-types";
import Image from "@insightfulscience/atomic-react/Image";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";
import Alert from "@insightfulscience/atomic-react/Alert";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";

import getPlasmidStaticMap from "../../providers/getPlasmidStaticMap";

const PlasmidStaticMap = ({ siteDomain, setID, plasmidID }) => {
	const [getPlasmidStaticImage, { isLoading, result: src, error }] =
		useFormAction(getPlasmidStaticMap);

	useEffect(() => {
		getPlasmidStaticImage(setID, plasmidID);
	}, []);

	return (
		<>
			{isLoading && <Paragraph>Loading plasmid static map...</Paragraph>}
			{src && <Image isBaseUrl={false} src={`https://${siteDomain}${src}`} />}
			{error && (
				<Alert
					status="error"
					title="Something went wrong"
					className="text-left mt-10"
				>
					Failed to fetch plasmid static map.
				</Alert>
			)}
		</>
	);
};

PlasmidStaticMap.propTypes = {
	siteDomain: string.isRequired,
	setID: string.isRequired,
	plasmidID: string.isRequired,
};

export default PlasmidStaticMap;
